import { FormikCounselorSelect } from "@/common/components/counselor-select/FormikCounselorSelect";
import { FormDialog } from "@/common/components/form-dialog/FormDialog";
import { useTranslation } from "@/translations";

import { AppointmentFormFields } from "../shared/AppointmentFormFields";
import { useAppointmentCreation } from "./hooks/useAppointmentCreation";

interface Props {
  onClose: () => void;
  /** Counselor whose calendar is shown; falls back to the current user when none is selected. */
  initialCounselorId?: string | null;
}

export function AppointmentCreationDialog({ onClose, initialCounselorId }: Props) {
  const { t } = useTranslation();
  const { formik, fieldOptions, handleIsAllDayChange, isSubmitDisabled } = useAppointmentCreation(
    onClose,
    initialCounselorId
  );

  return (
    <FormDialog
      title={t("calendar.appointmentCreation.title")}
      onClose={onClose}
      formik={formik}
      submitLabel={t("calendar.appointmentCreation.submitButton")}
      submitDisabled={isSubmitDisabled}
    >
      <AppointmentFormFields
        formik={formik}
        {...fieldOptions}
        onIsAllDayChange={handleIsAllDayChange}
        counselorField={
          <FormikCounselorSelect
            formik={formik}
            fieldName="counselorId"
            label={t("calendar.appointmentCreation.counselor")}
            required
          />
        }
      />
    </FormDialog>
  );
}
